export const Routes = {
	HOME: '/',
	LOGIN: '/login',
	FORGOT_PASSWORD: '/forgot-password',
	REQUEST_ACCESS: '/request-access',
	AGENDA: '/agenda',
	PROFILE: '/profile',
	LOGOUT: '/logout',
	WORK_ORDER_DETAIL: '/work-orders/$id',
	WORKSHEET_DETAIL: '/work-orders/$id/worksheets/$worksheetId',
	WORKSHEET_STEP_DETAIL: '/work-orders/$id/worksheets/$worksheetId/steps/$stepId',
	WORKSHEET_ADDITIONAL_PROTOCOL: '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId',
	WORKSHEET_MESSAGES: '/work-orders/$id/worksheets/$worksheetId/messages',
	ASSISTANCES: '/assistances',
	ASSISTANCE_CHAT: '/assistances/$id',
	ASSET_DETAIL: '/assets/$id',
} as const;
